import actions from "@/store/modules/users/actions";
import mutations from "@/store/modules/users/mutations";
import usersGetters from "@/store/modules/users/getters";
import qualifications from "@/store/modules/users/qualifications";
import experience from "@/store/modules/users/experience";
import languagesAndSkills from "@/store/modules/users/languagesAndSkills";

const state = {
  isFetchingApprovers: false,
  isFetchingVerifiers: false,
  isFetchingUserSettings: false,
  userSettings: null,
  isAddingUser: false,
  isEditingUserDetails: false,
  isFetchingUserRoles: false,
  isFetchingUserLocationGroupings: false,
  userLocationGroupings: [],
  isFetchingUserExperienceFunctions: false,
  userExperienceFunctions: [],
  bookingManagers: [],
  isFetchingBookingManagers: false,
  userDiversityTraits: {},
  isFetchingUserDiversityTraits: false,
  isFetchingUsers: false,
  users: []
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters: usersGetters,
  modules: {
    qualifications,
    experience,
    languagesAndSkills
  }
};
